import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import { BuilderEstimatorSteps } from "@/enums/BuilderEstimatorSteps";
  import BuilderStepDesktopNavigation from "./BuilderStepDesktopNavigation.vue";
  import BuilderStepMobileNavigation from "./BuilderStepMobileNavigation.vue";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderStepNavigationContainer',
  props: {
    steps: {},
    currentStep: {},
    totalPrice: {},
    errorOnCurrentStep: { type: Boolean },
    builderLogo: {},
    builderColor: {},
    houseDesign: {}
  },
  emits: [
    "select-next",
    "select-prev",
    "toggle-summary-modal",
  ],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const { isDesktop } = useIsDesktop(991);

  const emit = __emit;

  const onSelectNext = () => {
    emit("select-next");
  };

  const onSelectPrev = () => {
    emit("select-prev");
  };

  const onToggleSummaryModal = () => {
    emit("toggle-summary-modal");
  };

const __returned__ = { props, isDesktop, emit, onSelectNext, onSelectPrev, onToggleSummaryModal, ref, onMounted, get useIsDesktop() { return useIsDesktop }, get BuilderEstimatorSteps() { return BuilderEstimatorSteps }, BuilderStepDesktopNavigation, BuilderStepMobileNavigation, get HouseDesignInterface() { return HouseDesignInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})